// extracted by mini-css-extract-plugin
export default {"collapsibleContent":"ovOOqLUIA56w0btUsq3I","manage":"AWawr1HlouCbWVfq8D_h"};